import OnHoldIssueModal from '@/components/OnHoldIssueModal';
import { RootState } from '@/index';
import { CLSTAG, IssueStatus, IssueType } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

interface Props {
  vehicleName: string;
  disabled: boolean;
  closeDropdown: () => void;
}
const OnHoldIssue = (props: Props) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<'HOLD' | 'CANCEL_HOLD'>('HOLD');
  const { vehicleName, disabled, closeDropdown } = props;
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const currentIssue =
    issueList &&
    issueList.find(
      (issue: any) =>
        issue.vehicleName === vehicleName && issue.issueType === IssueType.OPS
    );
  const showOnHold = currentIssue?.issueStatus === IssueStatus.PROCESS;
  const showCancelOnHold = currentIssue?.issueStatus === IssueStatus.ON_HOLD;

  return (
    <>
      {!currentIssue || disabled ? (
        <button className="issue-command-btn" disabled>
          挂单
        </button>
      ) : showOnHold ? (
        <button
          className="issue-command-btn"
          onClick={() => {
            if (disabled) {
              return;
            }
            setOpen(true);
            setType('HOLD');
          }}
          clstag={clstagStr(CLSTAG.OnHoldIssue)}
        >
          挂单
        </button>
      ) : showCancelOnHold ? (
        <button
          className="issue-command-btn"
          onClick={() => {
            if (!currentIssue) {
              return;
            }
            setOpen(true);
            props.closeDropdown();
          }}
        >
          取消挂单
        </button>
      ) : null}
      <OnHoldIssueModal
        open={open}
        setOpen={setOpen}
        issueNumber={currentIssue?.issueNumber}
        type={type}
      />
    </>
  );
};
export default React.memo(OnHoldIssue);
